import React, { ReactElement } from 'react'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'
import { Theme, ToastNotification, ModalGlobalStyle } from 'lib/ui'

interface Props {
  theme: Theme
  children: ReactElement | ReactElement[]
}

export const ThemeProvider = ({ theme, children }: Props) => {
  return (
    <StyledThemeProvider theme={theme}>
      {children}
      <ToastNotification />
      <ModalGlobalStyle />
    </StyledThemeProvider>
  )
}
